import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DebitCreditListRes;
export const DebitCreditListTodo = createAsyncThunk('DebitCreditList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'debit_credit_note_list',
            data: {
                "fin_year": data?.fin_year,
                "vaccount_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "pageing": data?.pageSize,
                "ilimit": data?.pageLimit,
                "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "vtrans_code": "",
                "trans_type": data?.trans,
            },
            headers: { "Content-Type": "application/json" },

        })
        return DebitCreditListRes = res.data

    } catch (error) {
        return DebitCreditListRes = error.response.data
    }
});

const DebitCreditListSlice = createSlice({
    name: 'DebitCreditList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DebitCreditListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DebitCreditListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DebitCreditListSlice.reducer; 